import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../../apiCall';
import { baseUrl, customHeaders, indianProjectsBaseURL } from './../../../../../Containers/Config/index';

import { UPDATE_CAMPAIGN, UPDATE_CAMPAIGN_SUCCESS, UPDATE_CAMPAIGN_ERROR } from './../../../actionType';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* updateCampaign({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/campaign`,
      method: 'PUT',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders },
      data: payload?.data,
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message)
      cogoToast.success(`Campaign updated successfully!`);
      yield put({ type: UPDATE_CAMPAIGN_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      // yield put({ type: UPDATE_CAMPAIGN_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: UPDATE_CAMPAIGN_ERROR, payload: error });
  }
}

export function* watchUpdateCampaign() {
  yield takeEvery(UPDATE_CAMPAIGN, updateCampaign);
}

function* updateCampaignSaga() {
  yield all([fork(watchUpdateCampaign)]);
}

export default updateCampaignSaga;
